import { lazy } from "react";

// berita
const TambahKategoriBerita = lazy(() => import("./berita/TambahKategori"));
const DaftarKategoriBerita = lazy(() => import("./berita/DaftarKategori"));
const EditKategoriBerita = lazy(() => import("./berita/EditKategori"));
const TambahBerita = lazy(() => import("./berita/Tambah"));
const DaftarBerita = lazy(() => import("./berita/Daftar"));
const EditBerita = lazy(() => import("./berita/Edit"));

// potensi
const TambahKategoriPotensi = lazy(() => import("./potensi/TambahKategori"));
const DaftarKategoriPotensi = lazy(() => import("./potensi/DaftarKategori"));
const EditKategoriPotensi = lazy(() => import("./potensi/EditKategori"));
const TambahPotensi = lazy(() => import("./potensi/Tambah"));
const DaftarPotensi = lazy(() => import("./potensi/Daftar"));
const EditPotensi = lazy(() => import("./potensi/Edit"));

// informasi
const TambahKategoriInformasi = lazy(() =>
  import("./informasi/TambahKategori")
);
const DaftarKategoriInformasi = lazy(() =>
  import("./informasi/DaftarKategori")
);
const EditKategoriInformasi = lazy(() => import("./informasi/EditKategori"));
const TambahInformasi = lazy(() => import("./informasi/Tambah"));
const DaftarInformasi = lazy(() => import("./informasi/Daftar"));
const EditInformasi = lazy(() => import("./informasi/Edit"));

// slider
const DaftarHero = lazy(() => import("./hero/Daftar"));
const EditHero = lazy(() => import("./hero/Edit"));
const TambahHero = lazy(() => import("./hero/Tambah"));
const HeroSetting = lazy(() => import("./hero/Setting"));

export {
  TambahKategoriBerita,
  DaftarKategoriBerita,
  EditKategoriBerita,
  TambahBerita,
  DaftarBerita,
  EditBerita,
  TambahKategoriPotensi,
  DaftarKategoriPotensi,
  EditKategoriPotensi,
  TambahPotensi,
  DaftarPotensi,
  EditPotensi,
  TambahKategoriInformasi,
  DaftarKategoriInformasi,
  EditKategoriInformasi,
  TambahInformasi,
  DaftarInformasi,
  EditInformasi,
  DaftarHero,
  EditHero,
  TambahHero,
  HeroSetting,
};
